import type { Document, Folder } from '../types'

const folderNameCollator = new Intl.Collator('zh-CN', { numeric: true, sensitivity: 'base' })
export function compareFolderNames(a: Pick<Folder, 'name'>, b: Pick<Folder, 'name'>) { return folderNameCollator.compare(a.name || '', b.name || '') }

export function childFolders(folders: Folder[], parentId: string) {
  return folders.filter(folder => (folder.parent_id || 'root') === parentId).sort(compareFolderNames)
}

export function descendantFolderIds(folders: Folder[], folderId: string) {
  const ids = new Set([folderId]); const queue = [folderId]
  while (queue.length) { const parent = queue.shift()!; for (const child of folders) if ((child.parent_id || 'root') === parent && !ids.has(child.id)) { ids.add(child.id); queue.push(child.id) } }
  return ids
}

export function folderDocumentCount(folders: Folder[], documents: Document[], folderId: string) {
  const ids = descendantFolderIds(folders, folderId)
  return documents.filter(document => ids.has(document.folder_id || 'root')).length
}
